export default "__VITE_ASSET__BlDrYS0C__"